import { Injectable, InjectionToken } from '@angular/core';

export const INPUT_STYLING_SERVICE = new InjectionToken<InputStylingService>(
  'INPUT_STYLING_SERVICE',
);

function appendAutoGrowHeight(autoGrowHeight: boolean, isFocused: boolean, classes: string) {
  if (autoGrowHeight) {
    if (isFocused) {
      classes += ' max-h-48 absolute bg-white z-20';
    } else {
      classes += ' max-h-full';
    }
  }

  return classes;
}

export interface InputStylingService {
  getDefaultInputClasses: (
    value: unknown,
    isFocused: boolean,
    invalid: boolean,
    autoGrowHeight?: boolean,
  ) => string;
}

@Injectable()
export class ConsolidationInputStylingService implements InputStylingService {
  getDefaultInputClasses(value: unknown, isFocused: boolean, invalid: boolean): string {
    const successfullyConsolidated = value && !invalid;

    const border = successfullyConsolidated ? 'border-theme-green-500' : 'border-primary-500';

    const ring = isFocused
      ? successfullyConsolidated
        ? 'ring-theme-green-500'
        : 'ring-primary-500'
      : 'ring-transparent';

    return appendAutoGrowHeight(true, isFocused, `${border} ${ring} outline-none`);
  }
}

@Injectable()
export class DefaultInputStylingService implements InputStylingService {
  // TODO: Maybe replace with normal css by using angulars automatically added validation classes?
  //  see https://angular.dev/guide/forms/form-validation#control-status-css-classes
  getDefaultInputClasses(
    value: unknown,
    isFocused: boolean,
    invalid: boolean,
    autoGrowHeight = false,
  ): string {
    let classes = 'outline-none';

    // State 1: Feld ist leer + nicht fokussiert + n.fehlerhaft    => gelbe Border + transparenter Ring
    // State 3: Feld ist leer + fokussiert + n.fehlerhaft          => gelbe Border + gelber Ring
    // State 2: Feld ist leer + nicht fokussiert + fehlerhaft      => rote Border + transparenter Ring
    // State 4: Feld ist leer + fokussiert + fehlerhaft            => rote Border + roter Ring
    // State 5: Feld ist gefüllt + nicht fokussiert + n.fehlerhaft => graue Border + transparenter Ring
    // State 7: Feld ist gefüllt + fokussiert + n.fehlerhaft       => graue Border + grauer Ring
    // State 6: Feld ist gefüllt + nicht fokussiert + fehlerhaft   => rote Border  + transparenter Ring
    // State 8: Feld ist gefüllt + fokussiert + fehlerhaft         => rote Border + roter Ring

    if (invalid) {
      return isFocused
        ? classes + ' border-theme-red-500 ring-theme-red-500'
        : classes + ' border-theme-red-500 ring-transparent';
    }

    if (value) {
      classes += ' border-gray-400';
      if (isFocused) {
        classes += ' ring-gray-400';
      } else {
        classes += ' ring-transparent';
      }
    }

    if (!value) {
      classes += ' border-primary';
      if (isFocused) {
        classes += ' ring-primary';
      } else {
        classes += ' ring-transparent';
      }
    }

    return appendAutoGrowHeight(autoGrowHeight, isFocused, classes);
  }
}
